export default "__VITE_ASSET__3ec51855__"